import { ENDPOINTS, toSlug } from "@horseed/shared";
import { API_BASE_URL, apiRequest, getStoredZoneId } from "./http";

const { CATEGORIES, PRODUCTS } = ENDPOINTS;

// GET /api/v1/categories
export async function getCategories() {
  const json = await apiRequest(`${API_BASE_URL}${CATEGORIES.LIST}`);
  const arr = Array.isArray(json?.data) ? json.data : [];
  return arr.map(({ isPackage: _omit, name, ...rest }) => ({
    ...rest,
    name: name || "Unknown",
    Name: name || "Unknown", // kept for backward compat
    slug: toSlug(name || ""),
  }));
}

// GET /api/v1/Products/new
export async function getNewProducts() {
  const json = await apiRequest(`${API_BASE_URL}${PRODUCTS.NEW}`);
  return Array.isArray(json?.data) ? json.data : [];
}

// GET /api/v1/Products/sale
export async function getSaleProducts() {
  const json = await apiRequest(`${API_BASE_URL}${PRODUCTS.SALE}`);
  return Array.isArray(json?.data) ? json.data : [];
}

// POST /api/v1/Products/search
// filterModel: { q, categoryIds, sortColumn, sortDirection, active, featured, new, pageNumber, pageSize, zoneId }
export async function searchProducts(filterModel = {}, signal) {
  const body = { ...filterModel };
  if (body.zoneId == null) {
    // Zone ids are GUIDs, not numbers.
    const zoneId = getStoredZoneId();
    if (zoneId) body.zoneId = zoneId;
  }
  const json = await apiRequest(`${API_BASE_URL}${PRODUCTS.SEARCH}`, {
    method: "POST",
    body: JSON.stringify(body),
    signal,
  });
  const payload = json?.data ?? json;
  if (payload && Array.isArray(payload.items)) return payload;
  return { items: [], totalCount: 0, totalPages: 1 };
}

// GET /api/v1/Products/{id}
export async function getProductById(id) {
  if (!id) throw new Error("Product ID is required");
  const json = await apiRequest(`${API_BASE_URL}${PRODUCTS.BY_ID(id)}`);
  return json?.data ?? null;
}
